import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const nutritionInformationImporterSelectors = importerSelectors(
  'nutritionInformation.importer',
);

export default nutritionInformationImporterSelectors;
